import React from 'react';
import _ from 'lodash';
import { Information } from './common';
import { messageUtility } from '../../utilities/messageUtility';
import Styles from '../../styles/componentStyle/entrance/Users.scss';

export const BuildeeManagerApplyingModal = ({
  visible,
  buildeeManagerGrantRequest,
  onClose,
}) => {

  /**
   * 企業管理者申請中のメッセージ
   */
  const buildeeManagerApplyingMessage = (buildeeManagerGrantRequest) => {
    const request_user_name = !_.isNil(buildeeManagerGrantRequest)
      ? buildeeManagerGrantRequest.request_user_name
      : '';
    const target_user_name = !_.isNil(buildeeManagerGrantRequest)
      ? buildeeManagerGrantRequest.target_user_name
      : '';
    return (
      <React.Fragment>
        <div className='text-left'>
          <p>すでに企業管理者の申請中です。</p>
          <p className={Styles.buildee_request_user_info}>
            申請者：
            {request_user_name}
          </p>
          <p className={Styles.buildee_request_user_info}>
            企業管理者として登録するユーザー：
            {target_user_name}
          </p>
          <p>
            申請結果は、申請者および企業管理者として登録されたユーザーにメールで通知されます。
          </p>
          <p>申請が承認されるまでしばらくお待ちください。</p>
          <br />
          <p>※企業管理者の申請は会社ごとに1人までとなります。</p>
          <p>
            申請が承認されたユーザーは、他のユーザーに対して企業管理者権限の付与を行うことができます。
          </p>
          <p>
            2人目以降を設定したい場合は、利用者詳細・編集画面から他のユーザーの権限を設定してください。
          </p>
        </div>
      </React.Fragment>
    );
  };

  return (
    <Information
      visible={visible}
      title={messageUtility.getMessage('I-000-109')}
      message={buildeeManagerApplyingMessage(buildeeManagerGrantRequest)}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={onClose}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/BuildeeManagerApplyingModal.jsx